// define a mixin object
const axiosErrorManagement = {
    methods: {
        /**
         * SECTION -
         */
        handleAxiosErrors(error) {
            // Log the error to console in the first place
            console.log(error);
            /**
             * CASE - We have an error response
             */
            if (error.response) {
                //  Check if we have a message from Laravel
                if (error.response.status) {
                    // Set var
                    var status = error.response.status;

                    // CASE - 401 - We're no longer authenticated
                    if (status == 401) {
                        return {
                            type: "danger",
                            message:
                                "It looks like you're no longer logged in. Please refresh the page or log back in to continue",
                        };
                        // CASE - 403 - We have no business accessing this page
                    } else if (status == 403) {
                        return {
                            type: "warning",
                            message:
                                "It looks like you're not authorized to access this page. Please refresh the page or log back in to continue.",
                        };
                        // CASE - 500 - No idea what went wrong, but lets look into it
                    } else if (status == 500) {
                        return {
                            type: "danger",
                            message:
                                "There was an issue processing your request. An Admin has been notified and will look at the issue shortly. If the issue persists, please contact Support.",
                        };
                    }
                }
            }
            // Check if we have an error type / response
            // CASE - We have nothing, return a generic error
            return {
                type: "danger",
                message:
                    "There was an issue requesting data from the API. Please refresh the page and try again.",
            };
        },
    },
};

// Export
export default axiosErrorManagement;
